import { create } from "zustand";

export type GameScreen = "main-menu" | "board";

export const useGameScreenStore = create<{
  screen: GameScreen;
  switchToBoard(): void;
  switchToMainMenu(): void;
}>((set) => ({
  screen: "main-menu",
  switchToBoard: () => set({ screen: "board" }),
  switchToMainMenu: () => set({ screen: "main-menu" })
}));
